// @flow
import { getAllProducts, getProductItemById, getStateForProduct } from '~/core/state/products/selectors';

import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getIdFromProps } from '~/core/state/selectors';
import { SELECTED_PERIOD } from './constants';
import { TODAY } from '~/core/constants/periods';

export const getFrostProtectionForHeating = createSelector(getStateForProduct, state =>
    state.get('frostProtection', 7)
);

export const getAllHistory = createSelector(getAllProducts, state => state.history);

const getPeriodFromProps = (_, { period }) => period;

export const getIsSettingTemperature = createSelector(
    getProductItemById,
    product => product.get('isSettingTemperature') || false
);

export const getHistory = createSelector(getAllHistory, getIdFromProps, getPeriodFromProps, (history, id, period) =>
    history.get(id, fromJS({})).get(period.constant, fromJS({}))
);

export const getSelectedPeriod = createSelector(getAllHistory, getIdFromProps, (history, id) =>
    history.getIn([id, SELECTED_PERIOD], TODAY)
);

export const getIsReadyByEnabled = createSelector(
    getStateForProduct,
    state => (state && state.get('optimumStart')) || false
);



// WEBPACK FOOTER //
// ./src/core/state/products/heating/selectors.js